import { SelectOption } from '@globaleris/ui.library'
import {
  apiFetchConfigOperacionBalanceByOperationType,
  EnumOperationState,
  EnumSubTipoElemLog,
  EnumTipoOperacion,
  EnumTipoSujeto
} from '../../api'
import { apiViajesPOST } from '../../api/oData/endpoints/viajes'
import { apiFetchShips, apiFetchShipTravel } from '../../api/Pioneer/endpoints/ships/ships.api'
import { fetchSubjectsByTypesAPI } from '../../api/Pioneer/endpoints/subjects/subjects.api'
import { apiFetchLogisticElementsSelectOptionsBySubtypes } from '../../api/Pioneer/endpoints/logisticElements/logisticElements.api'
import { enumValueToKey } from '../../helpers'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import i18n from '../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../model'
import { ServiceResponse } from '../../model/serviceResponse'
import { getActiveBalanceZone, getActiveCompany, notifyError } from '../../redux'
import {
  operationsBalanceConfigMapperAPItoModel,
  shipsListItemMapperEdit,
  shipsListItemsMapper,
  subjectsSelectOptionMapper,
  travelPostMapper
} from './ships.mapper'
import ShipsModel from './ships.model'

export const FetchShips = (
  startDate?: Date,
  endDate?: Date,
  operationType?: number
): Promise<any[]> => {
  return apiFetchShips(startDate, endDate, operationType)
    .then(response => {
      return shipsListItemsMapper(response)
    })
    .catch(() => {
      notifyError('Fallo en la carga')
      return []
    })
}

export const fetchTravel = (travelId: number): Promise<ServiceResponse<any>> => {
  return apiFetchShipTravel(travelId)
    .then(response => {
      return createSuccessServiceResponse(shipsListItemMapperEdit(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const filterApplicableActionsConfiguration = (
  item: ShipsModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        if (item.shipOperations) {
          let indexPending = item.shipOperations.findIndex(
            x =>
              enumValueToKey(EnumOperationState, x.operationState) ===
              enumValueToKey(EnumOperationState, EnumOperationState.PendienteRenvio)
          )
          if (indexPending > -1) {
            applicableActionsConfiguration.push(configuration)
          }
        }
        break
      }
      case ActionIcons.ERROR: {
        if (item.shipOperations) {
          let indexPending = item.shipOperations.findIndex(
            item =>
              (item.operationQuantity !== item.operationTsoQuantity ||
                item.operationQuantity !== item.operationTsoQuantity) &&
              (enumValueToKey(EnumOperationState, item.operationState) ===
                enumValueToKey(EnumOperationState, EnumOperationState.Enviada) ||
                enumValueToKey(EnumOperationState, item.operationState) ===
                  enumValueToKey(EnumOperationState, EnumOperationState.Rechazado) ||
                enumValueToKey(EnumOperationState, item.operationState) ===
                  enumValueToKey(EnumOperationState, EnumOperationState.EnviadoKO))
          )
          if (indexPending > -1) {
            applicableActionsConfiguration.push(configuration)
          }
        }

        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const fetchOrigins = (type: string | number): Promise<SelectOption[]> => {
  if (
    enumValueToKey(EnumTipoOperacion, type) ===
    enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.DescargaBuque)
  ) {
    return apiFetchLogisticElementsSelectOptionsBySubtypes(
      [EnumSubTipoElemLog.OTR_PF, EnumSubTipoElemLog.OTR_PO],
      getActiveBalanceZone()?.id
    )
  } else if (
    enumValueToKey(EnumTipoOperacion, type) ===
    enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.CargaBuque)
  ) {
    return apiFetchLogisticElementsSelectOptionsBySubtypes(
      [EnumSubTipoElemLog.OTR_PF, EnumSubTipoElemLog.OTR_PO],
      getActiveBalanceZone()?.id
    )
  } else {
    return Promise.all([])
  }
}

export const fetchDestinations = (): Promise<SelectOption[]> => {
  return apiFetchLogisticElementsSelectOptionsBySubtypes(
    [EnumSubTipoElemLog.OTR_PF],
    getActiveBalanceZone()?.id
  )
}

export const fetchOwners = (): Promise<SelectOption[]> => {
  return fetchSubjectsByTypesAPI([EnumTipoSujeto.Mayorista], undefined, getActiveBalanceZone()?.id).then(
    subjectsSelectOptionMapper
  )
}

export const fetchLogisticElementsToItems = async (): Promise<SelectOption[]> => {
  return await fetchLogisticElements()
}

export const fetchLogisticElements = async (): Promise<SelectOption[]> => {
  return await apiFetchLogisticElementsSelectOptionsBySubtypes(
    await apiFetchConfigOperacionBalanceByOperationType([
      EnumTipoOperacion.DescargaBuque,
      EnumTipoOperacion.CargaBuque
    ]).then(response => {
      return operationsBalanceConfigMapperAPItoModel(response).map(
        item => item.logisticElementSubType
      )
    }),
    getActiveBalanceZone()?.id
  )
}

export const saveTravel = async (data: any): Promise<Boolean> => {
  // console.log('AITOR data', data);
  // console.log('AITOR travelPostMapper(data)', travelPostMapper(data));

  return await apiViajesPOST(travelPostMapper(data))
    .then(response => {
      return response
    })
    .catch(() => {
      return false
    })
}

export const modifyTravel = async (data: any): Promise<Boolean> => {
  // console.log('AITOR data', data);
  // console.log('AITOR travelPatchMapper(data)', travelPatchMapper(data));
  // return await apiViajesPATCH(travelPatchMapper(data))
  //   .then(response => {
  //     return response;
  //   })
  //   .catch(() => {
  //     console.log('ERROR PATCH!!!!!');
  //     return false;
  //   });
  return true
}

// export const sendTravels = async (operations: any[]): Promise<boolean> => {
//   apiMassiveDispatchesPOST(travelSendMapper(operations, getActiveCompany()?.id!)).catch(error => {
//     notifyError(i18n.t('ships:notifications.error.sendError'))
//     return false
//   })

//   return true
// }

//#region Checkers Actions

export const canEditTravels = (travel: ShipsModel | undefined): boolean => {
  //TODO: Preguntar si el if se sigue quedando así
  // if (moment(travel?.travelDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
  //   notifyError(i18n.t('ships:notifications.error.canEdit'));
  //   return false;
  // }

  return true
}

// export const canSendTravels = (travels: ShipsModel[] | undefined): boolean => {
//   let canSend = true

//   // travels?.forEach(element => {
//   //   if (element.state !== enumValueToKey(EnumEstadoViaje, EnumEstadoViaje.Pendiente)) {
//   //     notifyError(i18n.t('ships:notifications.error.canSend'));
//   //     canSend = false;
//   //   }
//   // });

//   if (canSend) {
//     travels?.forEach(travel => {
//       console.log('travel', travel.shipOperations)
//       travel.shipOperations?.forEach(operation => {
//         if (
//           enumValueToKey(EnumOperationState, operation.operationState) ===
//             enumValueToKey(EnumOperationState, EnumOperationState.PendienteRenvio) ||
//           enumValueToKey(EnumOperationState, operation.operationState) ===
//             enumValueToKey(EnumOperationState, EnumOperationState.Borrador)
//         ) {
//           canSend = false
//         }
//       })
//     })
//   }

//   return false
// }

//@endregion

//#region Ships global actions

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getQuantityDisagreementAction(), getStateDisagreementAction()]
}

const getQuantityDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    tooltip: i18n.t('translation:pages.allocations.dataTable.tooltips.quantityDisagreement')
  }
}

const getStateDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.ERROR,
    tooltip: i18n.t('translation:pages.allocations.dataTable.tooltips.stateDisagreement')
  }
}

//#endregion
